// import SizingDisplay from "../utility/SizingDisplay";
function Footer() {
  return (
    <div className="p-5">
      <p>© Aaron Worku 2025</p>
      <p className="disclaimer">Uses open-source software under MIT, Apache-2.0, BSD, and other licenses.</p>
    </div>
  );
}

export default Footer;
